import maifudLogo from "@/assets/maifud_logo.svg";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTrigger,
} from "@/components/ui/sheet";
import { useMenu } from "@/services/context/MobileMenuContext";
import { Menu } from "lucide-react";
import { MenuNav } from "./MenuNav";

export const MobileNav = () => {
    const { isOpen, closeMenu, openMenu } = useMenu();
    return (
        <Sheet
            open={isOpen}
            onOpenChange={(open) => (open ? openMenu() : closeMenu())}
        >
            <SheetTrigger
                onClick={openMenu}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white shadow-sm"
            >
                <Menu size={22} className="text-primary" />
            </SheetTrigger>
            <SheetContent
                className="w-[88vw] max-w-sm"
                onPointerDownOutside={closeMenu}
            >
                <SheetHeader>
                    <img alt="Maifud Logo" src={maifudLogo} className="w-32" />
                </SheetHeader>
                <MenuNav />
            </SheetContent>
        </Sheet>
    );
};
